import { FormControl } from '@mui/material';
import { BaseFormControlProps } from './BaseFormControl.types';

/**
 * The form control wrapper for constructing labelled
 * controls like the `Select` or `Radio`.
 *
 * @param classes - {@link BaseFormControlProps.classes classes} description.
 * @param error - {@link BaseFormControlProps.error error} description.
 * @param children - {@link BaseFormControlProps.children children} description.
 */
export const BaseFormControl = ({
    classes,
    error,
    children,
}: BaseFormControlProps) => {
    return (
        <FormControl
            variant={'standard'}
            role={'presentation'}
            classes={{
                ...classes,
            }}
            error={error}
        >
            {children}
        </FormControl>
    );
};